/* ============================================================================
   The swatches page. Plain script, no library.

   Four behaviours:

   1. materialsNav  - on scroll, add `.is-pinned` once scrollY passes the nav's
      resting offsetTop; then walk the .ghost spacers and mark the
      last one we are past as the active nav item.
   2. careDetails   - the open button adds `.is-on` to the sibling panel; the
      close button removes it.
   3. swatchesCart  - a tile's button toggles: /cart/add.js with quantity 1, or
      /cart/change.js with quantity 0 to remove. After either, re-read the cart
      and set data-in-cart and the label on EVERY tile from what is actually in
      it, which is what keeps the page honest across tabs.
   4. addAll / removeAll - optional [data-add-all] / [data-remove-all] buttons
      per material group, using /cart/add.js items[] and /cart/update.js.

   The reveal images on the description are handled here too, since this is
   the only page that has any.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('.fabrics');
  if (!root) return;

  var C = '.fabrics__';
  var arr = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ cart calls */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity, properties: {} })
    }).then(function (r) { return r.json(); });
  }
  function addMultipleToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  function changeCart(id, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantity })
    }).then(function (r) { return r.json(); });
  }
  function updateMultipleCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  /* Tell the rest of the theme, so the header count and the cart drawer
     update the same way as from a product page. */
  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { res: cart } }));
  }

  /* ------------------------------------------------------------ 1. the nav */
  function materialsNav() {
    var nav = root.querySelector(C + 'cloths-nav');
    if (!nav) return;
    var ghosts = arr(C + 'cloth .ghost', root);
    var initialTop = nav.offsetTop;
    var ticking = false;

    function onScroll() {
      if (window.scrollY >= initialTop) nav.classList.add('is-pinned');
      else nav.classList.remove('is-pinned');

      var closest = null;
      ghosts.forEach(function (ghost) {
        if (window.scrollY > ghost.offsetTop) {
          closest = nav.querySelector('a[href="#' + ghost.id + '"]');
        }
      });
      if (closest) {
        arr(':scope > p', nav).forEach(function (p) { p.classList.remove('is-on'); });
        closest.parentNode.classList.add('is-on');
      }
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
    }, { passive: true });
    onScroll();
  }

  /* --------------------------------------------------- 2. the care details */
  function careDetails() {
    arr(C + 'sub-cloth-more button.care-show', root).forEach(function (open) {
      open.addEventListener('click', function () {
        var panel = open.parentNode.querySelector(C + 'sub-cloth-desc');
        if (panel) panel.classList.add('is-on');
      });
    });
    arr(C + 'sub-cloth-more button.care-shut', root).forEach(function (close) {
      close.addEventListener('click', function () { close.parentNode.classList.remove('is-on'); });
    });
    /* Escape closes the panel - a full-viewport scrim needs a
       keyboard exit. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      arr(C + 'sub-cloth-desc.is-on', root).forEach(function (p) { p.classList.remove('is-on'); });
    });
  }

  /* ------------------------------------------- 3. reconcile against /cart.js */
  function verifyFromCart() {
    return getCart().then(function (cart) {
      arr(C + 'sub-cloth-chip', root).forEach(function (swatch) {
        var span = swatch.querySelector(C + 'plus span');
        if (!span) return;
        span.innerHTML = 'Add to Cart';
        swatch.setAttribute('data-in-cart', '0');
        cart.items.forEach(function (item) {
          if (String(item.variant_id) === swatch.getAttribute('data-variant')) {
            swatch.setAttribute('data-in-cart', '1');
            span.innerHTML = 'Remove';
          }
        });
      });
      syncGroupButtons();
      /* The header count is rendered server-side, so adding or removing a
         swatch without a page load would leave `Cart [n]` stale. Set it here. */
      document.querySelectorAll('.j-basket-n').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      return cart;
    });
  }

  function syncGroupButtons() {
    arr(C + 'cloth', root).forEach(function (material) {
      var addAll = material.querySelector('[data-add-all]');
      var removeAll = material.querySelector('[data-remove-all]');
      if (!addAll || !removeAll) return;
      var tiles = arr('[data-swatches-variant]', material);
      var allAdded = tiles.length > 0 && tiles.every(function (t) { return t.dataset.inCart === '1'; });
      if (allAdded) { removeAll.classList.remove('gone'); addAll.classList.add('gone'); }
      else          { addAll.classList.remove('gone');    removeAll.classList.add('gone'); }
    });
  }

  /* --------------------------------------------------------- 3. the buttons */
  function swatchesCart() {
    verifyFromCart();
    arr(C + 'sub-cloth-chip', root).forEach(function (swatch) {
      var atc = swatch.querySelector(C + 'plus');
      if (!atc) return;
      atc.addEventListener('click', function () {
        atc.setAttribute('disabled', 'true');
        var variantId = swatch.getAttribute('data-variant');
        var inCart = parseInt(swatch.getAttribute('data-in-cart'), 10);
        var call = inCart ? changeCart(variantId, 0) : addToCart(variantId, 1);
        call.then(function () { return verifyFromCart(); })
            .then(function (cart) { announce(cart); })
            .catch(function (err) { console.error(err); })
            .then(function () { atc.removeAttribute('disabled'); });
      });
    });
  }

  /* --------------------------------------------------- 4. add all / remove all */
  function addAll() {
    arr('[data-add-all]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var material = btn.closest(C + 'cloth');
        var items = arr(C + 'sub-cloth-chip', material)
          .filter(function (s) { return s.dataset.inCart === '0' && s.dataset.material === btn.dataset.material; })
          .map(function (s) { return { id: parseInt(s.dataset.variant, 10), quantity: 1 }; });
        if (!items.length) return;
        addMultipleToCart(items)
          .then(function () { return verifyFromCart(); })
          .then(announce)
          .catch(function (err) { console.error(err); });
      });
    });
  }

  function removeAll() {
    arr('[data-remove-all]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var material = btn.closest(C + 'cloth');
        var updates = {};
        arr(C + 'sub-cloth-chip', material)
          .filter(function (s) { return s.dataset.inCart === '1' && s.dataset.material === btn.dataset.material; })
          .forEach(function (s) { updates[parseInt(s.dataset.variant, 10)] = 0; });
        if (!Object.keys(updates).length) return;
        updateMultipleCart(updates)
          .then(function () { return verifyFromCart(); })
          .then(announce)
          .catch(function (err) { console.error(err); });
      });
    });
  }

  /* ------------------------------------------------- the reveal on hover
     Each material group may carry an image with id "<anchor>_image"; a word in
     the description carries id "<anchor>-hover". Hover shows it, leaving hides
     it. Off below 768, where the CSS hides the images outright. */
  function imageReveal() {
    arr('.over-pic', root).forEach(function (img) {
      var anchor = img.id.replace(/_image$/, '');
      var word = document.getElementById(anchor + '-hover');
      if (!word) return;
      word.addEventListener('mouseover', function () {
        img.style.zIndex = 99;
        img.style.display = 'block';
      });
      word.addEventListener('mouseleave', function () {
        img.style.display = 'none';
      });
    });
  }

  materialsNav();
  careDetails();
  swatchesCart();
  addAll();
  removeAll();
  imageReveal();
})();
